import { lazy } from 'react';
import { AppRoute } from './types';

// Lazy load auth pages
const Login = lazy(() => import('@pages/auth/Login'));
const ForgotPassword = lazy(() => import('@pages/auth/ForgotPassword'));
const Signup = lazy(() => import('@pages/auth/Signup'));

export const publicRoutes: AppRoute[] = [
  {
    path: '/login',
    element: <Login />,
    title: 'Login',
  },
  {
    path: '/forgot-password',
    element: <ForgotPassword />,
    title: 'Forgot Password',
  },
  {
    path: '/signup',
    element: <Signup />,
    title: 'Sign Up',
  },
];
